import { render, staticRenderFns } from "./WizzardBusqueda.vue?vue&type=template&id=98985960&"
import script from "./WizzardBusqueda.vue?vue&type=script&lang=js&"
export * from "./WizzardBusqueda.vue?vue&type=script&lang=js&"
import style0 from "./WizzardBusqueda.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports